<div class="d-flex justify-content-between">
  <i *ngIf="icons[automationType] as icon" [ngClass]="icon.icon + ' ' + icon.color" style="font-size: 36px"></i>

  <div class="d-flex align-items-center gap-3" (click)="$event.stopPropagation()">
    <app-form-switch
      [disabled]="1 | isReadonlyRole"
      [inline]="true"
      [value]="automation.status === 1"
      (valueChange)="onTogglePause()"
    ></app-form-switch>
    <button class="btn btn-sm btn-secondary-danger parent-hover:show" (click)="onDelete()">
      <i class="cs-icon cs-icon-trash"></i>
    </button>
  </div>
</div>
<div
  *ngIf="!!automation.attributes?.name"
  class="text-semi-bold mt-3 text-truncate"
  [matTooltip]="(automation.attributes?.name | automationGridCardName) || (automation.event | eventName)"
>
  {{ automation.attributes?.name | automationGridCardName }}
</div>
<div
  *ngIf="!automation.attributes?.name"
  class="text-semi-bold mt-3 text-truncate"
  [matTooltip]="automation.attributes?.name || (automation.event | eventName)"
>
  {{ automation.event | eventName }}
</div>
<div class="mt-3 d-flex align-items-center">
  <div class="flex-1 text-truncate text-light text-sm">
    <ng-container> {{ automation.event | eventName }} • </ng-container>
    <span [matTooltip]="automation.lastupdate | epoch">
      {{ automation.lastupdate | epoch }}
    </span>
  </div>

  <ng-container *ngIf="automation.handler | eventHandler; let handler">
    <i [ngClass]="handler.icon + ' ' + handler.color" class="text-lg" [matTooltip]="handler.title"></i>
  </ng-container>
</div>
